// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "aedb38e/js/" + chunkId + ".js";
};